import { FC } from 'react';
import MuiTable, { TableProps } from '@mui/material/Table';

export const Table: FC<TableProps> = props => <MuiTable {...props} />;
